// Core
import React from "react";

// Instruments
import education from "../theme/assets/data/education.json";

// Components
import SectionHeading from "./SectionHeading";
import Eduspace from "./Eduspace";

export default class Education extends React.Component {
    render () {
        const eduspaceList = education.map((eduspace) => {
            return (
                <Eduspace
                    degree = { eduspace.degree }
                    eduspace = { eduspace.eduspace }
                    key = { eduspace.id }
                    period = { eduspace.period }
                />
            );
        });

        return (
            <div className = 'education'>
                <SectionHeading number = '04.' title = 'Образование' />
                {eduspaceList}
                <span className = 'copyright'>2018 © Илон Маск</span>
            </div>
        );
    }
}
